var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaestro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.90257C0 1.90041 1.68552 0.277344 3.76471 0.277344H28.2353C30.3145 0.277344 32 1.90041 32 3.90257V18.4035C32 20.4056 30.3145 22.0287 28.2353 22.0287H3.76471C1.68552 22.0287 0 20.4056 0 18.4035V3.90257Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2353 1.18365H3.76471C2.20531 1.18365 0.941176 2.40095 0.941176 3.90257V18.4035C0.941176 19.9051 2.20531 21.1224 3.76471 21.1224H28.2353C29.7947 21.1224 31.0588 19.9051 31.0588 18.4035V3.90257C31.0588 2.40095 29.7947 1.18365 28.2353 1.18365ZM3.76471 0.277344C1.68552 0.277344 0 1.90041 0 3.90257V18.4035C0 20.4056 1.68552 22.0287 3.76471 22.0287H28.2353C30.3145 22.0287 32 20.4056 32 18.4035V3.90257C32 1.90041 30.3145 0.277344 28.2353 0.277344H3.76471Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1247 10.8861C18.1247 14.2426 15.3315 16.9635 11.8858 16.9635C8.44021 16.9635 5.64697 14.2426 5.64697 10.8861C5.64697 7.52957 8.44021 4.80859 11.8858 4.80859C15.3315 4.80859 18.1247 7.52957 18.1247 10.8861Z",
    fill: "#ED0006"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2185 10.8861C26.2185 14.2426 23.4252 16.9635 19.9796 16.9635C16.534 16.9635 13.7407 14.2426 13.7407 10.8861C13.7407 7.52957 16.534 4.80859 19.9796 4.80859C23.4252 4.80859 26.2185 7.52957 26.2185 10.8861Z",
    fill: "#0099DF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9327 6.26074C17.2742 7.37546 18.1247 9.03415 18.1247 10.8864C18.1247 12.7386 17.2742 14.3973 15.9327 15.512C14.5913 14.3973 13.7407 12.7386 13.7407 10.8864C13.7407 9.03415 14.5913 7.37546 15.9327 6.26074Z",
    fill: "#6C6BBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestro);
export default __webpack_public_path__ + "static/media/maestro.9a7dd01da7a49b1c58676abab91f29ab.svg";
export { ForwardRef as ReactComponent };